export default __webpack_public_path__ + "static/media/chevron-right.9f5f3276.svg";